module.exports = __webpack_public_path__ + "img/tb-3.ea05d7b7.jpg";